import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=dd54e9fe&"
var script = {}
import style0 from "./Map.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Map.vue"
export default component.exports